export const NOTIFICATION_STREAM = {
  START_IN: 'Live Stream starts in',
  COMMING_SOON: 'Live Stream starting soon',
  UNAVAILABLE: 'Live Stream currently unavailable',
};

export const WITHIN_TRIGGER_SEC_TIME = 3600;
